import { PERMISSIONS } from '../../../App/constants';
import { useCheckPermission } from '../../../shared/Helpers/hooks';
import { CustomAccordion, Text } from '../../../shared/uiComponents';
import BT from './BT';
import CredentialedBCBA from './credentialedBCBA';
import NotCredentialedBCBA from './notCredentialedBCBA';

const AccordionList = () => {
	const ASSIGN_BCBA = useCheckPermission(PERMISSIONS.SOAPNOTE.ASSIGN_BCBA);
	const ASSIGN_RBT = useCheckPermission(PERMISSIONS.SOAPNOTE.ASSIGN_RBT);

	const data = [
		{
			id: 0,
			name: `BCBA - credentialed`,
			isAllowed: ASSIGN_BCBA.permissionGranted,
			panel: CredentialedBCBA,
		},
		{
			id: 1,
			name: `BCBA - not credentialed`,
			isAllowed: ASSIGN_BCBA.permissionGranted,
			panel: NotCredentialedBCBA,
		},
		{ id: 2, name: `BT`, isAllowed: ASSIGN_RBT.permissionGranted, panel: BT },
	];

	return (
		<>
			{data
				.filter((x) => x.isAllowed)
				.map((header) => (
					<CustomAccordion
						key={header.name}
						HeaderContent={() => <Text title={header.name} fontWeight="semiBold" />}
						Content={header.panel}
					/>
				))}
		</>
	);
};

export default AccordionList;
